import produce from 'immer';
import _ from 'lodash';

import { RESET_STATE } from 'store/global/actions';

import { DOCUMENTS_ACTION_TYPE } from '../actions';

const initialState = {
  documents: {},
  selectedDocumentsIds: [],
};

const documentsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case DOCUMENTS_ACTION_TYPE.GET_DOCUMENTS_LIST_TYPE:
        draft.documents = payload || initialState.documents;
        draft.selectedDocumentsIds = [];
        break;

      case DOCUMENTS_ACTION_TYPE.GET_DOCUMENTS_LIST_SILENT_TYPE:
        // Merge per entry instead of replacing: the silent (popover) fetch carries a
        // narrower payload than the Documents tab's load, so a wholesale replace would
        // silently drop the tab's extraction fields, deleted rows, and selection.
        Object.entries(payload || {}).forEach(([id, documentEntry]) => {
          draft.documents[id] = { ...state.documents[id], ...documentEntry };
        });
        break;

      case DOCUMENTS_ACTION_TYPE.UPDATE_DOCUMENT:
      case DOCUMENTS_ACTION_TYPE.RESTORE_DOCUMENT:
        draft.documents[payload.id] = payload;
        break;

      case DOCUMENTS_ACTION_TYPE.GET_DOCUMENT_BY_ID:
        if (!payload.id) {
          break;
        }

        draft.documents[payload.id] = { ...draft.documents[payload.id], ...payload };
        break;

      case DOCUMENTS_ACTION_TYPE.UPDATE_DOCUMENT_CONTENT:
        if (!payload.id) {
          break;
        }

        draft.documents[payload.id] = { ...draft.documents[payload.id], ...payload };
        break;

      case DOCUMENTS_ACTION_TYPE.DELETE_DOCUMENT:
        delete draft.documents[payload.documentId];
        draft.selectedDocumentsIds = _.without(draft.selectedDocumentsIds, payload.documentId);
        break;

      case DOCUMENTS_ACTION_TYPE.GET_AI_EXTRACTION_RESULT: {
        const { aiAnalysisResult, id } = payload;

        if (!id) {
          break;
        }

        draft.documents[id] = {
          ...draft.documents[id],
          aiAnalysisResult,
        };
        break;
      }

      case DOCUMENTS_ACTION_TYPE.TOGGLE_DOCUMENT_SELECTION: {
        const isDocumentSelected = draft.selectedDocumentsIds.includes(payload);

        draft.selectedDocumentsIds = isDocumentSelected
          ? _.without(draft.selectedDocumentsIds, payload)
          : [...draft.selectedDocumentsIds, payload];
        break;
      }

      case DOCUMENTS_ACTION_TYPE.RESET_SELECTED_DOCUMENTS:
        draft.selectedDocumentsIds = [];
        break;

      case RESET_STATE:
        return initialState;

      default:
        break;
    }
  });

export default documentsReducer;
